<template><div ref="chart" class="year-count-box"></div></template>

<script>
export default {
  name: 'YearCountCharts',
  props: { data: { type: Array, default: () => [] } },
  watch: { data: { handler: 'updateChart', deep: true } },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart)
    this.chart.setOption({
      color: ['#409eff'],
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: 10, right: 18, top: 22, bottom: 12, containLabel: true },
      xAxis: { type: 'category', axisLine: { lineStyle: { color: '#c0c4cc' } }, axisTick: { show: false }, axisLabel: { color: '#909399', fontSize: 10, interval: 'auto' } },
      yAxis: { type: 'value', axisLabel: { color: '#909399', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(220, 223, 230, .65)' } } },
      series: [{ name: '作品数', type: 'bar', barMaxWidth: 25, itemStyle: { borderRadius: [4, 4, 0, 0] } }]
    })
    this.updateChart()
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.chart.resize())
      this.observer.observe(this.$refs.chart)
    } else window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    else window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    resizeChart() { if (this.chart) this.chart.resize() },
    updateChart() {
      if (this.chart) this.chart.setOption({ xAxis: { data: this.data.map(item => item.name) }, series: [{ data: this.data.map(item => item.value) }] })
    }
  }
}
</script>

<style scoped>.year-count-box { width: 100%; height: 100%; min-height: 0; }</style>
